import { createFileRoute } from '@tanstack/react-router';
import { AdminGalleryPage } from '@/components/admin/admin-gallery';

export const Route = createFileRoute('/admin/gallery')({
  component: AdminGalleryPage,
});
